import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const checkPoint = defineConnector({
  identifier: "checkPoint",
  name: "Check Point",
  tagLine: "Network security and threat prevention",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.host}/web_api/login`,
        jsonBody: {
          "api-key": app.secret.apiKey,
        },
      },
      extract: { from: "jsonPath", paths: ["sid"] },
      apply: { kind: "header", name: "x-chkp-sid" },
    }),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Check Point SmartConsole, go to **Manage & Settings > Blades > Management API > Advanced Settings**. Ensure the API is enabled. Then create an API key under **Manage > Users & Administrators** by selecting a user and generating an API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Management server host",
          required: true,
          placeholder: "checkpoint.example.com",
          helperText:
            "Your Check Point Management Server hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for authenticating to the Management API.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => ({
      url: `https://${host}/web_api/show-session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    }),
  },
});
